export default __webpack_public_path__ + "static/media/Blooded Vambraces of the Tribes.383f2d61.jpg";